module.exports = __webpack_public_path__ + "img/CersoLeekInkBlack.72912171.png";